import * as $ from 'jquery';
import { $body } from '../Core/Body';
import { default as debounce } from "lodash-es/debounce";
import { onLoad } from 'Core/Events';
import "selectric";

export const Collections = (():any => {

    const Selector = {
        FORM: '#collection-homepage-form',
        SELECT: '.collection-filter-select'
    };

    const submitFilterForm = debounce(() => $(Selector.FORM).submit(), 500);

    onLoad(() => {
		const $select = $(Selector.SELECT);

		if($select.selectric !== undefined)
			$select.selectric();
	});

    async function applyFilters() {
        submitFilterForm();
    }

    function onPreventSubmit(event) {
        event.preventDefault();
        let selectedFields = {};
        let inputSelect = $(this).find('select[name]');

        inputSelect.each(function () {
            if ($(this).val() !== '') {
                selectedFields[$(this).attr('name')] = $(this).val();
            }
        });

        let newGetQuery = $.param(selectedFields);
        let newLocation = window.location.origin + window.location.pathname;
        if (newGetQuery) {
            newLocation = newLocation + '?' + newGetQuery;
        }

        window.location.href = newLocation;
    }


    $body.on("change", Selector.SELECT, applyFilters);
    $body.on("submit", Selector.FORM, onPreventSubmit);
})();
import * as $ from 'jquery';
import { $body } from '../Core/Body';
import { default as debounce } from "lodash-es/debounce";
import { onLoad } from 'Core/Events';
import "selectric";

export const Collections = (():any => {

    const Selector = {
        FORM: '#collection-homepage-form',
        SELECT: '.collection-filter-select'
    };

    const submitFilterForm = debounce(() => $(Selector.FORM).submit(), 500);

    onLoad(() => {
		const $select = $(Selector.SELECT);

		if($select.selectric !== undefined)
			$select.selectric();
	});

    async function applyFilters() {
        submitFilterForm();
    }

    function onPreventSubmit(event) {
        event.preventDefault();
        let selectedFields = {};
        let inputSelect = $(this).find('select[name]');

        inputSelect.each(function () {
            if ($(this).val() !== '') {
                selectedFields[$(this).attr('name')] = $(this).val();
            }
        });

        let newGetQuery = $.param(selectedFields);
        let newLocation = window.location.origin + window.location.pathname;
        if (newGetQuery) {
            newLocation = newLocation + '?' + newGetQuery;
        }

        window.location.href = newLocation;
    }


    $body.on("change", Selector.SELECT, applyFilters);
    $body.on("submit", Selector.FORM, onPreventSubmit);
})();
